<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.87492 12H4.12493V8.25H2.26343L5.99992 3.11252L9.73642 8.25H7.87492V12Z" fill="#B8CDD7"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.12498 2.25004H10.875C11.4963 2.25004 12 1.74642 12 1.12498C12 0.503624 11.4963 0 10.875 0H1.12498C0.503624 0 0 0.503624 0 1.12498C0 1.74642 0.503624 2.25004 1.12498 2.25004ZM6.37496 0.750029H5.62495V1.50004H6.37496V0.750029ZM7.12501 0.750029H7.87502V1.50004H7.12501V0.750029ZM4.87499 0.750029H4.12507V1.50004H4.87499V0.750029Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style scoped>

</style>